import React from 'react';
import { globals } from 'common-ui';
import type { SearchClient } from 'algoliasearch/lite';

const weCanHelpPluginHeader = () => <span className="aa-SourceHeaderTitle">Can we help</span>;
const weCanHelpPluginItem = ({ item }: any) => (
  <a href={item.url as string} target="_blank" rel="noopener noreferrer">
    {item.label as string}
  </a>
);

export function createWeCanHelpPlugin(searchClient: SearchClient) {
  return {
    getSources({ query: helpQuery }: { query: string }) {
      return searchClient
        .search([
          {
            indexName: globals.algoliaIndexName as string,
            query: helpQuery,
          },
        ])
        .then(({ results: innerResults }) => {
          const searchHits = 'hits' in innerResults[0] ? innerResults[0].hits : [];

          // Show help options if no results OR if the search is empty
          if (searchHits.length === 0 || !helpQuery) {
            return [
              {
                sourceId: 'weCanHelpPlugin',
                getItems() {
                  return [
                    { label: 'Inspire Me', url: '/jsp/contenthub/uk/home.jsp' },
                    { label: 'Help & FAQs', url: '/customer-services' },
                    { label: 'Contact Us', url: '/jsp/customerservice/common/contactus.jsp' },
                  ];
                },
                templates: {
                  header: weCanHelpPluginHeader,
                  item: weCanHelpPluginItem,
                },
              },
            ];
          }
          return [];
        });
    },
  };
}
